module.exports = __webpack_public_path__ + "static/media/how2.dcd79147.png";